import { render } from "./SwdCurrencyInput.vue?vue&type=template&id=56fd2762"
import script from "./SwdCurrencyInput.vue?vue&type=script&lang=js"
export * from "./SwdCurrencyInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__